{
  "pageTitle": "Operations",
  "branch": "Branch",
  "businessDate": "Business date",
  "archiveBanner": "Archive",
  "frozenNotice": "The system is temporarily frozen for a year-management operation",
  "revolvingBalanceRequired": "No {{product}} operation is possible until the carried balance is entered for the current business date",
  "product": {
    "DIESEL": "Diesel",
    "PETROL": "Petrol",
    "switchLabel": "Product",
    "confirmSwitchTitle": "Switch to petrol?",
    "confirmSwitchDescription": "The operations screen will switch to petrol operations instead of diesel. You can switch back at any time.",
    "confirmSwitchConfirm": "Switch"
  },
  "operations": {
    "revolvingBalance": "Carried balance",
    "purchase": "Purchase",
    "cashSale": "Cash sale",
    "debtSale": "Debt sale",
    "debtRepayment": "Debt repayment",
    "payment": "Payment",
    "receipt": "Receipt"
  },
  "shortcutHint": "Shortcut: {{digit}}",
  "fields": {
    "cashBalance": "Cash balance",
    "barrelPurchasePrice": "Barrel purchase price",
    "jerrycanPurchasePrice": "Jerrycan purchase price",
    "barrelSalePrice": "Barrel sale price",
    "jerrycanSalePrice": "Jerrycan sale price",
    "lessJerrycans": "Less jerrycans",
    "notes": "Notes",
    "debtor": "Debtor",
    "debtorPlaceholder": "Search by debtor name...",
    "debtorInvalidPhone": "Invalid number: this movement will not reach Customers or WhatsApp.",
    "debtorSearchEmpty": "No matching debtors",
    "vehicle": "Vehicle",
    "vehicleNone": "No vehicle",
    "vehiclePlaceholder": "Select vehicle",
    "amount": "Amount",
    "personName": "Person name",
    "statement": "Statement",
    "quantities": "Quantities"
  },
  "quantityGrid": {
    "barrels": "Barrels",
    "jerrycans": "Jerrycans"
  },
  "summary": {
    "title": "Operation summary",
    "totalBarrels": "Total barrels",
    "totalJerrycans": "Total jerrycans",
    "barrelsAmount": "Barrels amount",
    "jerrycansAmount": "Jerrycans amount",
    "amount": "Amount",
    "finalTotal": "Final total",
    "currentBalance": "Current balance",
    "debtLimit": "Debt limit",
    "withinLimit": "Within the allowed debt limit",
    "overLimit": "Exceeds the allowed debt limit",
    "placeholder": "—"
  },
  "drawers": {
    "revolvingBalance": {
      "title": "Carried balance",
      "description": "Record the carried cash balance, with category quantities if any.",
      "save": "Save"
    },
    "purchase": {
      "title": "Purchase",
      "description": "Record a purchase with editable prices.",
      "save": "Save"
    },
    "cashSale": {
      "title": "Cash sale",
      "description": "Record a cash sale with editable prices.",
      "save": "Save"
    },
    "debtSale": {
      "title": "Debt sale",
      "description": "Record a sale charged to a debtor's account.",
      "save": "Save"
    },
    "debtRepayment": {
      "title": "Debt repayment",
      "description": "Record a repayment against a debtor's account.",
      "save": "Save"
    },
    "payment": {
      "title": "Payment",
      "description": "Record an outgoing cash payment.",
      "save": "Save"
    },
    "receipt": {
      "title": "Receipt",
      "description": "Record an incoming cash amount.",
      "save": "Save"
    },
    "cancel": "Cancel",
    "discardTitle": "Discard changes?",
    "discardDescription": "The entered data has not been saved. It will be lost if you continue.",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing"
  },
  "confirm": {
    "title": "Confirm save",
    "description": "This operation will be recorded permanently under the current branch and business date.",
    "operation": "Operation",
    "product": "Product",
    "commit": "Save",
    "cancel": "Cancel"
  },
  "result": {
    "title": "Operation completed successfully",
    "revolvingBalanceSaved": "Carried balance saved successfully",
    "print": "Print",
    "close": "Close"
  },
  "shiftClose": {
    "action": "Close diesel and petrol shift",
    "title": "Close diesel and petrol shift",
    "description": "Closes the diesel and petrol shifts together and moves to the next business date. No product operation is possible until its carried balance is entered.",
    "closingDate": "Business date being closed",
    "nextDate": "Next business date",
    "balanceEntered": "Carried balance entered",
    "balanceMissing": "Carried balance not entered",
    "password": "Close password",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "success": "Diesel and petrol shift closed. New business date {{date}}"
  },
  "validation": {
    "required": "This field is required",
    "positive": "The value must be greater than zero",
    "nonNegative": "The value must not be negative",
    "atLeastOneQuantity": "Enter at least one barrel or jerrycan quantity",
    "invalidNumber": "The value must be a whole number",
    "tooManyDecimals": "At most five decimal places are allowed."
  },
  "archive": {
    "title": "Archive — read-only",
    "description": "The operations app is not available in the archive environment. No transaction can be entered here.",
    "backToSystems": "Systems"
  },
  "shiftStatus": {
    "title": "Shift status",
    "active": "Active",
    "closed": "Closed",
    "closedAt": "Closed on"
  },
  "inventoryMode": {
    "notice": "Inventory count mode is on: purchases, sales, payments and receipts are saved as pending until they are posted"
  },
  "lookup": {
    "title": "Transaction lookup",
    "field": "Transaction number",
    "placeholder": "Scan the code or type the transaction number",
    "search": "Search",
    "scan": "Scan code",
    "scanTitle": "Scan code",
    "scanHint": "Point the camera at the QR code on the receipt",
    "typeInstead": "Type the number",
    "camera": {
      "denied": "The camera cannot be used. Allow camera access in the browser settings or type the number",
      "unavailable": "Camera scanning is not available in this browser, type the number"
    },
    "detailsTitle": "Transaction details",
    "reference": "Transaction number",
    "type": "Transaction type",
    "product": "Product",
    "dateTime": "Date and time",
    "employee": "Employee",
    "pdaEmployee": "PDA employee",
    "customer": "Customer",
    "phone": "Phone number",
    "barrelPrice": "Barrel price",
    "jerrycanPrice": "Jerrycan price",
    "pricedAt": "Completed at",
    "deliveredAt": "Delivery time",
    "category": "Category",
    "quantity": "Quantity",
    "close": "Close",
    "confirmDelivery": "Confirm delivery",
    "deliverTitle": "Confirm delivery of transaction {{reference}}?",
    "deliverDescription": "The transaction will be recorded as delivered under your name. Delivery cannot be undone.",
    "deliverySaved": "Delivery recorded",
    "kind": {
      "PURCHASE": "Purchase",
      "PDA_PURCHASE": "PDA purchase",
      "CASH_SALE": "Cash sale",
      "DEBT_SALE": "Debt sale",
      "DEBT_REPAYMENT": "Debt repayment",
      "PAYMENT": "Payment",
      "RECEIPT": "Receipt",
      "REVOLVING_BALANCE": "Carried balance",
      "PDA_SALE": "PDA sale"
    },
    "status": {
      "PENDING_PRICE": "Awaiting completion",
      "PRICED": "Completed",
      "PENDING_DELIVERY": "Pending delivery",
      "DELIVERED": "Delivered",
      "RECORDED": "Recorded",
      "CANCELLED": "Cancelled"
    },
    "block": {
      "WRONG_PRODUCT": "This is a {{product}} transaction, switch the product to {{product}} to continue",
      "CANCELLED": "The transaction is cancelled",
      "ALREADY_PRICED": "The transaction is already completed",
      "ALREADY_DELIVERED": "Already delivered",
      "NO_ACTION": "No action is available for this transaction",
      "NOT_PERMITTED": "You do not have permission to continue this transaction. Contact the system administrator"
    },
    "postingStatus": "Posting status",
    "posting": {
      "POSTED": "Posted",
      "PENDING": "Not posted"
    },
    "continue": "Continue transaction",
    "completeTitle": "Complete transaction",
    "completeDescription": "The data recorded on the PDA is filled in. Enter or confirm the two purchase prices, then complete the transaction.",
    "completeSubmit": "Complete transaction",
    "completeInvalid": "Enter barrel and jerrycan prices greater than zero",
    "completeConfirmDescription": "The transaction will be completed with these prices in your name. The quantities and the business date do not change, and it cannot be completed again.",
    "quantitiesLocked": "Quantities are as the PDA employee recorded them and cannot be changed here.",
    "completed": "Transaction completed",
    "completeSaleDescription": "The data recorded on the PDA is filled in. Enter or confirm the two sale prices, then complete the transaction.",
    "completeSaleConfirmDescription": "The transaction will be completed with these prices in your name and will then wait for delivery. The quantities and the business date do not change, and it cannot be completed again."
  }
}
